/** Concatena classes condicionais sem dependencia externa. */
export function cn(...values: (string | false | null | undefined)[]): string {
  return values.filter(Boolean).join(' ');
}
